function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "st0",
  d: "M25.3,121.1c-0.2-0.1-0.5-0.1-0.7-0.2c-3.3-1-6-3-7.4-6.9c-0.9-2.7-0.7-5.5,0-8.2c1.3-4.7,3.9-8,7.6-10.2 c2.2-1.4,4.4-2.5,6.8-3c3.3-0.7,6.6-0.4,9.7,0.9c1.6,0.7,2.4,0.2,2.9-1.7c0.2-0.9,0.4-1.8,0.4-2.8c0.1-7.2,0.2-14.3,0.3-21.5 c0.1-10.5,0.2-21,0.3-31.5c0-2.4,0-4.8,0.1-7.2c0-1.3,0.5-2,1.5-2.4c1.1-0.4,2.1,0,2.6,1c0.7,1.3,1.4,2.6,1.9,4 c1.2,3.2,4.7,10.9,6.6,13.5c2.2,3,10.8,13.9,13,17c1.4,2,1.9,3.6,2.7,5.8c0.3,0.9,0.5,1.7,0.6,2.6c0.7,6.4,0.3,14.7-1.8,20.8 c-0.3,0.9-0.9,1.4-1.7,1.4c-0.8,0-1.3-0.6-1.4-1.4c-0.2-0.8-0.3-1.7-0.3-2.5c0.3-4.8,0.3-9.3-0.2-14.3c-0.5-5.1-2.7-10-6.1-13.8 c-2.6-2.9-5.2-5.3-6.2-6.4c-0.4-0.5-1-0.8-1.6-1c-1.9-0.7-4.9-0.5-5,2.1c0,3.7,0,3.7,0,7.5C50,71.1,49.9,79.5,49.8,88 c0,5.3-0.1,10.6-0.2,16c-0.1,2.9-1.2,5.4-2.8,7.6c-1.6,2.2-3.5,3.9-5.6,5.4c-2.5,1.8-5.1,3.4-8,4.1c0,0,0,0,0,0 C30.6,121.1,28,121.1,25.3,121.1z"
}), React.createElement("path", {
  className: "st0",
  d: "M94.5,93.7c-0.2,0-0.4-0.1-0.6-0.2c-0.6-0.4-0.9-1.2-0.5-1.8c11.5-18.2-0.7-31.9-1.2-32.5 c-0.5-0.5-0.4-1.4,0.1-1.8c0.5-0.5,1.4-0.4,1.8,0.1c0.1,0.2,20.8,14.6,1.5,35.5C95.3,93.4,94.9,93.7,94.5,93.7z"
}), React.createElement("path", {
  className: "st0",
  d: "M114.5,118.5c-0.4,0-0.8-0.1-1.2-0.3c-1.1-0.7-1.7-2.2-0.9-3.3c32.6-41.3-0.9-77.4-1.8-78.4 c-0.9-1-0.8-2.5,0.2-3.4c1-0.9,2.5-0.8,3.4,0.2c0.2,0.3,40.5,36.5,2.4,84C116,118,115.3,118.5,114.5,118.5z"
}));

var SvgAudioSetupIcon = function SvgAudioSetupIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAudioSetupIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/audio-setup-icon.7efe220e.svg";
export { ForwardRef as ReactComponent };